import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  QUESTIONNAIRE_STORAGE_KEY,
  QUESTIONNAIRE_STORAGE_VERSION,
  getQuestionnaireSnapshot
} from '@/utils/questionnaire'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/index/index.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/question-start',
    name: 'questionStart',
    component: () => import(/* webpackChunkName: "question" */ '@/pages/question-start/index.vue')
  },
  {
    path: '/question',
    name: 'question',
    component: () => import(/* webpackChunkName: "question" */ '@/pages/question/index.vue')
  },
  {
    path: '/result-analysis',
    name: 'resultAnalysis',
    component: () => import(/* webpackChunkName: "question" */ '@/pages/result-analysis/index.vue'),
    beforeEnter(to, from, next) {
      if (window.innerWidth >= 768) {
        next({ name: 'pricing', query: to.query, replace: true })
        return
      }

      next()
    }
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import(/* webpackChunkName: "pricing" */ '@/pages/pricing/index.vue')
  },
  {
    path: '/result',
    name: 'result',
    component: () => import(/* webpackChunkName: "result" */ '@/pages/result/index.vue')
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/mine/index.vue')
  },

  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/about/index.vue')
  },

  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/privacy/index.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/service/index.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    }else{
      return {
        x: 0,
        y: 0
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (!['index', 'questionStart'].includes(to.name)) {
    next()
    return
  }

  try {
    const storedValue = window.localStorage.getItem(QUESTIONNAIRE_STORAGE_KEY)
    if (!storedValue) {
      next()
      return
    }

    const stored = JSON.parse(storedValue)
    if (!stored || typeof stored !== 'object') {
      window.localStorage.removeItem(QUESTIONNAIRE_STORAGE_KEY)
      next()
      return
    }

    const query = { ...to.query }
    if (stored.gender) query.gender = stored.gender

    if (
      stored.version === QUESTIONNAIRE_STORAGE_VERSION &&
      stored.stage === 'pricing'
    ) {
      next({
        name: 'pricing',
        query,
        replace: true
      })
      return
    }

    const answers = stored.answers && typeof stored.answers === 'object'
      ? stored.answers
      : {}
    const snapshot = getQuestionnaireSnapshot(answers)
    const hasStarted = Boolean(stored.startedAt) || snapshot.answeredCount > 0
    const canResume = stored.version === QUESTIONNAIRE_STORAGE_VERSION &&
      hasStarted &&
      snapshot.answeredCount < snapshot.totalQuestions

    if (!canResume) {
      next()
      return
    }

    next({
      name: 'question',
      query,
      replace: true
    })
  } catch (error) {
    window.localStorage.removeItem(QUESTIONNAIRE_STORAGE_KEY)
    next()
  }
})

export default router
